import React from 'react';

import ItemSelector from '@components/item-selector/ItemSelector';
import EditTagModal from '@features/lead-management/components/edit-tag-modal/EditTagModal';
import { Tag } from 'types/lead-management';

interface TagSelectorProps {
  isOpen: boolean;
  onClose: () => void;
  onSelectTag: (tag: Tag) => void;
  onCreateTag: (tagName: string, color?: string) => void;
  onEditTag?: (tag: Tag) => void;
  onUpdateTag?: (newTag: Tag) => void;
  selectedTags?: Tag[];
  className?: string;
  searchValue?: string;
  tagOptions?: Tag[];
  selectedColor?: string;
  onColorChange?: (color: string) => void;
  showColorSelector?: boolean;
  showEditButton?: boolean;
  EditModalComponent?: React.ComponentType<any>;
  createButtonClassName?: string;
  itemRowClassName?: string;
  showItemDividers?: boolean;
  positionFixed?: boolean;
  getAnchorRect?: () => DOMRect | null;
  alwaysShowColorPill?: boolean;
  labelName?: string;
  nonEditableFields?: string[];
  showSelectionTooltip?: boolean;
}

const TagSelector = ({
  isOpen,
  onClose,
  onSelectTag,
  onCreateTag,
  onEditTag,
  onUpdateTag,
  selectedTags = [],
  className = '',
  searchValue = '',
  tagOptions = [],
  selectedColor,
  onColorChange,
  showColorSelector = true,
  showEditButton = true,
  EditModalComponent,
  createButtonClassName,
  itemRowClassName,
  showItemDividers,
  positionFixed,
  getAnchorRect,
  alwaysShowColorPill,
  labelName,
  nonEditableFields,
  showSelectionTooltip
}: TagSelectorProps) => (
  <ItemSelector<Tag>
    isOpen={isOpen}
    onClose={onClose}
    onSelectItem={onSelectTag}
    onCreateItem={onCreateTag}
    onEditItem={onEditTag}
    onUpdateItem={onUpdateTag}
    selectedItems={selectedTags}
    className={className}
    searchValue={searchValue}
    itemOptions={tagOptions}
    showColorSelector={showColorSelector}
    showEditButton={showEditButton}
    nonEditableFields={nonEditableFields}
    createButtonText="Create"
    noItemsText="No tags found"
    EditModalComponent={EditModalComponent || EditTagModal}
    selectedColor={selectedColor}
    onColorChange={onColorChange}
    itemType="tag"
    createButtonClassName={createButtonClassName}
    itemRowClassName={itemRowClassName}
    showItemDividers={showItemDividers}
    positionFixed={positionFixed}
    getAnchorRect={getAnchorRect}
    alwaysShowColorPill={alwaysShowColorPill}
    labelName={labelName}
    showSelectionTooltip={showSelectionTooltip}
  />
);

export default TagSelector;
